// The network a session talks to, named for people (docs/08-app-design.md
// section 3, the header's network pill). Shared by the app frame (Shell)
// and the entrance's site header (NetworkPill), so both say the same word.
// An RPC the app does not recognise is named by its hostname, which the
// pill truncates.

export function networkLabel(rpcUrl: string): string {
  try {
    const host = new URL(rpcUrl).hostname;
    if (host === 'localhost' || host === '127.0.0.1') return 'Local';
    if (host.includes('devnet')) return 'Devnet';
    if (host.includes('mainnet') || host === 'solana-rpc.publicnode.com') return 'Mainnet';
    return host;
  } catch {
    return 'Custom';
  }
}
